/**
 * Display-title helpers for JSON schema properties.
 */

import type { SchemaObject } from '@/types/valueSegment';

/**
 * Resolve the user-visible title for a schema property.
 *
 * LogicAppsUX convention prefers `x-ms-summary` (a curated human-readable
 * name that connectors often set to something like "CC") over the raw
 * `title` (which is frequently the property name like "ccRecipients"),
 * over a caller-provided fallback, over the property name itself.
 *
 * Order:
 *   1. `schema['x-ms-summary']` if non-empty string
 *   2. `schema.title` if set
 *   3. `fallback` if provided
 *   4. `propName`
 */
export function getSchemaDisplayTitle(
  schema: SchemaObject | undefined,
  propName: string,
  fallback?: string,
): string {
  const summary = schema?.['x-ms-summary'];
  if (typeof summary === 'string' && summary.length > 0) return summary;
  if (schema?.title) return schema.title;
  return fallback ?? propName;
}
